<template>
  <div class="referral">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.referral') }}
        </h3>
      </div>
      <div class="box-body">
        <div>
          <table
            id="referral-table"
            class="table table-hover table-striped table-bordered"
          >
            <thead>
              <tr>
                <th>{{ $t('table.action') }}</th>
                <th>{{ $t('table.createdAt') }}</th>
                <th>{{ $t('table.refereeName') }}</th>
                <th>{{ $t('table.refereePhone') }}</th>
                <th>{{ $t('table.referrerName') }}</th>
                <th>{{ $t('table.referrerPhone') }}</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('string.referralList'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.refreshTable()
      this.oTable.draw(true)
      this.loadAction()
    }
  },
  methods: {
    refreshDataTable () {
      this.oTable.draw(true)
    },
    deleteReferral (id) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/refers/delete', { id: id })
            .then((response) => {
              if (response.data.code === 1) {
                this.refreshDataTable()
              }
              self.$swal({
                title: self.$t('string.deleted!'),
                text: self.$t('string.theRecordHasBeenDeleted!'),
                type: response.data.code === 1 ? 'success' : 'error',
                confirmButtonText: self.$t('button.ok')
              })
            })
        }
      })
    },
    refreshTable () {
      const self = this
      return $('#referral-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/refers',
          data: (d) => {
            d.labelShow = self.labelShow
            d.labelEdit = self.$t('label.edit')
            d.labelDelete = self.$t('label.delete')
            d.noPermission = self.$t('string.noPermission')
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false,
            width: '8%',
            title: this.$t('table.action')
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false,
            width: '8%',
            title: this.$t('table.createdAt')
          },
          { data: 'referee_name', name: 'referee_name', width: '8%', title: this.$t('table.refereeName') },
          {
            data: 'referee_phone',
            name: 'referee_phone',
            width: '8%',
            title: this.$t('table.refereePhone')
          },
          {
            data: 'referred_name',
            name: 'referred_name',
            width: '8%',
            title: this.$t('table.referrerName')
          },
          {
            data: 'referred_phone',
            name: 'referred_phone',
            width: '8%',
            title: this.$t('table.referrerPhone')
          }
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        },
        fixedColumns: true
      })
    },
    loadAction () {
      this.clearEventHandlers([
        '.referral-show',
        '.referral-edit',
        '.referral-delete'
      ])
      const self = this
      $(document).on('click', '.referral-show', function () {
        const id = $(this).attr('data-referral')
        self.$router.push({
          name: 'ReferralShow',
          params: { id: id }
        })
      })
      $(document).on('click', '.referral-edit', function () {
        const id = $(this).attr('data-referral')
        self.$router.push({
          name: 'ReferralEdit',
          params: {
            id: id
          }
        })
      })
      $(document).on('click', '.referral-delete', function () {
        self.deleteReferral($(this).attr('data-referral'))
      })
    }
  },
  mounted () {
    this.oTable = this.refreshTable()
    this.loadAction()
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
